import React from "react";
import TablePagination from "@material-ui/core/TablePagination";
import { PaginationActions } from "./actions";

export const Pagination = ({ options }) => {
  return (
    <TablePagination
      rowsPerPageOptions={[]}
      count={options.totalItems}
      rowsPerPage={options.itemsPerPage}
      page={options.page}
      onChangePage={(n) => console.log(n)}
      ActionsComponent={PaginationActions}
    />
  );
};
